import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getServePage } from "@/api/managementCenter/serveManage";
export default {
  name: "SelectServe",
  components: {},
  props: {},
  data: function data() {
    return {
      loading: false,
      isSelectServe: false,
      alreadyData: [],
      alreadyDataId: [],
      serveList: [],
      total: 0,
      paramSearch: {
        current: 1,
        size: 10,
        serveName: ""
      }
    };
  },
  computed: {
    selectLen: function selectLen() {
      return this.alreadyData.length;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    getServeList: function getServeList() {
      var _this = this;

      this.loading = true;
      getServePage(this.paramSearch).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          var records = data.data.records || [];
          _this.serveList = records.map(function (item) {
            return {
              serve_id: item.id,
              server_name: item.serveName,
              checked: _this.alreadyDataId.indexOf(item.id) == -1 ? false : true
            };
          });
          _this.total = data.data.total;
        } else {
          _this.serveList = [];

          _this.$message.warning(data.msg || "加载异常！");
        }
      }).catch(function (err) {
        _this.serveList = [];
        _this.loading = false;

        _this.$message.error("服务器异常!");
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.paramSearch.current = val;
      this.getServeList();
    },
    sureSelect: function sureSelect() {
      this.$emit("sureSelect", this.alreadyData);
      this.isSelectServe = false;
    },
    cancel: function cancel() {
      this.isSelectServe = false;
    },
    openDialog: function openDialog(data) {
      var _this2 = this;

      this.isSelectServe = true;
      this.alreadyData = data.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          checked: true
        });
      });
      this.$nextTick(function () {
        _this2.paramSearch.current = 1;
        _this2.paramSearch.size = 10;

        _this2.getServeList();
      });
    },
    handleServeChecked: function handleServeChecked(val, id, serve) {
      if (!val) {
        var data = this.alreadyData.filter(function (i) {
          return id != i.serve_id;
        });
        this.alreadyData = data;
      } else {
        this.alreadyData.push(serve);
      }
    },
    handleAlreadyChecked: function handleAlreadyChecked(val) {
      if (!val) {
        var data = this.alreadyData.filter(function (i) {
          return i.checked;
        });
        var obj = this.alreadyData.find(function (i) {
          return !i.checked;
        });
        this.serveList.forEach(function (i) {
          if (obj.serve_id == i.serve_id) {
            i.checked = false;
          }
        });
        this.alreadyData = data;
      }
    }
  },
  watch: {
    alreadyData: function alreadyData(val) {
      this.alreadyDataId = val.map(function (i) {
        return i.serve_id;
      });
    },
    isSelectServe: function isSelectServe(val) {
      if (!val) {
        this.alreadyData = [];
        this.alreadyDataId = [];
        this.serveList = [];
        this.total = 0;
        this.paramSearch = {
          current: 1,
          size: 10,
          keywords: ""
        };
      }
    }
  },
  filters: {}
};